<script>
import i18n from '@/helpers/i18n'

import simplebar from 'simplebar-vue'
import { layoutComputed, authComputed } from '@/state/helpers'
import FullscreenBtn from '../shared/fullscreen-btn'
import ModuleDropdown from './module-dropdown'
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    }
  },
  computed: {
    ...layoutComputed,
    ...authComputed
  },
  components: {
    FullscreenBtn,
    ModuleDropdown
  },
  data () {
    return {
      languages: [
        {
          flag: require('@/assets/images/flags/us.jpg'),
          language: 'en',
          title: 'English'
        },
        {
          flag: require('@/assets/images/flags/french.jpg'),
          language: 'fr',
          title: 'French'
        }
      ],
      current_language: i18n.locale,
      text: null,
      flag: null,
      value: null
    }
  },
  mounted () {},
  methods: {
    toggleRightSidebar () {
      this.$parent.toggleRightSidebar()
    },
    toggleMenu () {
      let element = document.getElementById('topnav-menu-content')
      element.classList.toggle('show')
    },
    setLanguage (locale, country, flag) {
      this.current_language = locale
      this.text = country
      this.flag = flag
      i18n.locale = locale
    }
  },
  watch: {
    type: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'dark':
              document.body.setAttribute('data-topbar', 'dark')
              break
            case 'light':
              document.body.setAttribute('data-topbar', 'light')
              document.body.removeAttribute('data-layout-size', 'boxed')
              break
            case 'colored':
              document.body.setAttribute('data-topbar', 'colored')
              document.body.removeAttribute('data-layout-size', 'boxed')
              break
            default:
              document.body.setAttribute('data-topbar', 'dark')
              break
          }
        }
      }
    },
    width: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'boxed':
              document.body.setAttribute('data-layout-size', 'boxed')
              break
            case 'fluid':
              document.body.setAttribute('data-layout-mode', 'fluid')
              document.body.removeAttribute('data-layout-size')
              break
            default:
              document.body.setAttribute('data-layout-mode', 'fluid')
              break
          }
        }
      }
    }
  }
}
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box p-0">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="17" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo_oms.svg" alt height="30" />
            </span>
            <span class="logo-lg">
              <div class="d-flex align-items-center justify-content-center">
                <img src="@/assets/images/logo_oms.svg" alt height="30" />
                <span
                  class="mb-0 mx-2 text-white font-weight-light font-size-18"
                  >OMS bv</span
                >
              </div>
            </span>
          </router-link>
        </div>
        <button
          id="toggle"
          type="button"
          class="btn btn-sm mr-2 font-size-16 d-lg-none header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <module-dropdown v-if="false" />

        <!-- App Search-->
        <form class="app-search d-none d-lg-block" v-if="false">
          <div class="position-relative">
            <input type="text" class="form-control" placeholder="Search..." />
            <span class="bx bx-search-alt"></span>
          </div>
        </form>
      </div>

      <div class="d-flex">
        <fullscreen-btn class="mr-4" />

        <b-btn variant="black" v-if="false">
          <i class="bx bx-user"></i>
        </b-btn>

        <app-quick-add-form-btn class="mr-1" />

        <app-cart-btn />

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <b-avatar size="30" variant="info" class="mx-2"
              ><i class="bx bx-user"></i
            ></b-avatar>
            <span class="d-none d-xl-inline-block ml-1">{{
              userProfile.name
            }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <b-dropdown-item>
            <router-link tag="span" :to="{ name: 'account' }">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              {{ $t('profile') }}
            </router-link>
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"
            ></i>
            {{ $t('logout') }}
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
